export const LASSIE_LOAD_CARRIER_IDS = ['TOTE'];
export const HIK_LOAD_CARRIER_IDS = ['TOTE'];
